import * as React from 'react';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
    ISignInItem,
    ISignInLoading,
    ISignInLocalAccount /*ISignInSocialAccount, ISignInSocialItem,*/,
    ISignInViewProps
} from '@msdyn365-commerce-modules/account-management/src/modules/sign-in/./sign-in';

const LocalAccount: React.FC<ISignInLocalAccount> = ({ localAccount, items, forgetPassword, disclaimer, error, signInButton }) => {
    return (
        <Node {...localAccount}>
            {items &&
                items.map((item: ISignInItem) => {
                    return (
                        <Node key={item.key} {...item.wrapper}>
                            {item.label}
                            {item.error}
                            {item.input}
                        </Node>
                    );
                })}
            {forgetPassword}
            {disclaimer}
            {error}
            {signInButton}
        </Node>
    );
};
/*
const SocialAccount: React.FC<ISignInSocialAccount> = ({
    socialAccounts,
    items,
}) => {

    return (
        <Node {...socialAccounts}>
            {items && items.map((item: ISignInSocialItem) => {
                return (
                    <Node key={item.key} {...item.button}>
                        {item.image}
                        {item.text}
                    </Node>
                );
            })}
        </Node>
    );
};
*/
const SignInLoading: React.FC<ISignInLoading> = ({ modal, modalBody, icon, message }) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const SignInView: React.FC<ISignInViewProps> = props => {
    const {
        signIn,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        signInSection,
        signUpSection,
        signInSectionHeading,
        signInLocalAccount,
        /*signInSocialAccount,*/
        signUpSectionHeading,
        signUpDescription,
        signUpLink
    } = props;
    const canonicalDomain = props.signIn.moduleProps.context.request.canonicalDomain;
    const sitePath =
        props.signIn.moduleProps.context.request.sitePath && props.signIn.moduleProps.context.request.sitePath !== null
            ? props.signIn.moduleProps.context.request.sitePath
            : '';
    const requestUrl: string = `https://${canonicalDomain}${sitePath}`;
    
    const handleGaGuestCheckout = React.useCallback(() => {
        window.dataLayer.push({
            event: 'gaEvent',
            eventCategory: 'Account',
            eventAction: 'Guest checkout​',
            eventLabel: 'click'  
        })
    }, [])

    const handleGaSignUp = React.useCallback(() => {
        window.dataLayer.push({
            event: 'gaEvent',
            eventCategory: 'Account',
            eventAction: 'Iscrizione',
            eventLabel: 'click'  
        });
    }, [])

    return (
        <Module {...signIn}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <SignInLoading {...loading} />}
            <Node {...aadConainer}>
                <Node {...signInSection} className={`col-md-4 offset-md-1 ${signInSection.className}`}>
                    {signInSectionHeading}
                    {LocalAccount(signInLocalAccount)}
                    {/*SocialAccount(signInSocialAccount)*/}
                </Node>
                <Node {...signUpSection} className={`col-md-4 ${signUpSection.className}`}>
                    {signUpSectionHeading}
                    {signUpDescription}
                    <div onClick={handleGaGuestCheckout}>
                        <a className={'msc-cart__btn-guestcheckout'} href={`${requestUrl}/checkout`}>
                            Guest Checkout
                        </a>
                    </div>
                    <div onClick={handleGaSignUp}>
                        {signUpLink}
                    </div>
                </Node>
            </Node>
        </Module>
    );
};

export default SignInView;
